// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "v1.0-2025Jun10-797-ga908b20f-dirty",
    "hash": "ga908b20f",
    "distance": 797,
    "tag": "v1.0-2025Jun10",
    "semver": null,
    "suffix": "797-ga908b20f-dirty",
    "semverString": "",
    "version": "0.0.1"
};
/* tslint:enable */
